import React from 'react';
import { string } from 'prop-types';
import { urlStringForPathKey } from '@paddl/utils-js';
import { ActionWrapper, MenuWrapper, NavigationWrapper, MenuItem, PageTitleWrapper } from './PublicNav.styles';
import menuLinks from './navigationConfiguration';
import { Logos, Button } from '../..';
const {
  horizontal: HorizontalLogo
} = Logos;
export const LargeViewportMenu = _ref => {
  let {
    pathname,
    loginUrl,
    registerUrl,
    pageTitle
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuWrapper, null, /*#__PURE__*/React.createElement("a", {
    href: "/"
  }, /*#__PURE__*/React.createElement(HorizontalLogo, {
    className: "large-logo"
  })), !pageTitle ? /*#__PURE__*/React.createElement(NavigationWrapper, null, menuLinks.map(_ref2 => {
    let {
      name,
      href
    } = _ref2;
    return /*#__PURE__*/React.createElement(MenuItem, {
      href: href,
      active: typeof (href === null || href === void 0 ? void 0 : href.endsWith) === 'function' ? href === null || href === void 0 ? void 0 : href.endsWith(pathname) : false,
      key: href
    }, name);
  })) : /*#__PURE__*/React.createElement(PageTitleWrapper, null, pageTitle)), /*#__PURE__*/React.createElement(ActionWrapper, null, /*#__PURE__*/React.createElement(Button, {
    href: loginUrl || urlStringForPathKey('login'),
    size: "small"
  }, "Log In"), /*#__PURE__*/React.createElement(Button, {
    href: registerUrl || urlStringForPathKey('register'),
    variant: "contained",
    size: "small"
  }, "Sign Up")));
};
LargeViewportMenu.propTypes = {
  pathname: string.isRequired,
  loginUrl: string,
  registerUrl: string,
  pageTitle: string
};
LargeViewportMenu.defaultProps = {
  loginUrl: '',
  registerUrl: '',
  pageTitle: ''
};